import { Hand, Sprout, Package, Scale, Globe } from "lucide-react";
import { VALUES } from "../../data/collection";
import { Reveal } from "./Reveal";

const ICONS = { hand: Hand, leaf: Sprout, package: Package, scale: Scale, globe: Globe };

export default function Values() {
  return (
    <section
      data-testid="values"
      className="relative bg-[#FDFBF7] text-[#050505] border-b border-black/10"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20 py-14 md:py-20">
        <div className="grid grid-cols-2 gap-y-12 gap-x-6 sm:grid-cols-3 lg:grid-cols-5">
          {VALUES.map((v, i) => {
            const Icon = ICONS[v.icon] || Hand;
            return (
              <Reveal key={v.label} delay={i * 0.06} className="flex flex-col items-center text-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-black/25">
                  <Icon className="h-6 w-6" strokeWidth={1} />
                </span>
                <span className="mt-4 font-body text-[11px] md:text-xs uppercase tracking-[0.24em] text-black/70">
                  {v.label}
                </span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
